module.exports = __webpack_public_path__ + "problems1.32e96ace.png";